import React from "react";
// import { Link } from "gatsby";
import "tachyons";

export default ({ fullname, company, image, description }) => (
  <article class=" b--black-10">
    <a class="db pv4 ph3 ph0-l no-underline black dim" href="#0">
      <div class="flex flex-column flex-row-ns">
        <div class="pr3-ns mb4 mb0-ns w-100 w-20-ns">
          <img src={image} class="db" alt={fullname} />
        </div>
        <div class="w-100 w-60-ns pl3-ns">
          <h1 class="f3 fw1 baskerville mt0 lh-title">
            {fullname} - {company}
          </h1>
          <p class="f6 f5-l lh-copy">{description}</p>
          {/* <p class="f6 lh-copy mv0">By Robin Darnell</p> */}
        </div>
      </div>
    </a>
  </article>
);
